import { authAPIClient } from '../lib/authAPI'

const defaultTransport = {
  list: (organisationId, engagementId) => authAPIClient.makeRequest(`/assessments?organisation_id=${encodeURIComponent(organisationId)}&engagement_id=${encodeURIComponent(engagementId)}`, { method: 'GET' }),
  save: assessment => authAPIClient.makeRequest('/assessments', { method: 'POST', body: assessment }),
  remove: input => authAPIClient.makeRequest('/assessments', { method: 'DELETE', body: input })
}
export class AssessmentStorage {
  static organisationId = null
  static engagementId = null
  static transport = defaultTransport

  static configure({ organisationId, engagementId = null, transport = defaultTransport }) {
    this.organisationId = organisationId || null
    this.engagementId = engagementId || null
    this.transport = transport
  }

  static clearContext() {
    this.organisationId = null
    this.engagementId = null
    this.transport = defaultTransport
  }

  static requireContext({ engagement = false } = {}) {
    if (!this.organisationId) throw new Error('Active organisation is required')
    if (engagement && !this.engagementId) throw new Error('Active engagement is required')
  }

  static async getAllAssessments() {
    this.requireContext({ engagement: true })
    const response = await this.transport.list(this.organisationId, this.engagementId)
    return response.assessments || []
  }

  static async saveAssessment(assessmentData) {
    this.requireContext({ engagement: true })
    if (!assessmentData.id) return { success: false, error: 'No assessment ID provided' }
    const response = await this.transport.save({
      ...assessmentData,
      organisation_id: this.organisationId,
      engagement_id: this.engagementId,
      answers: this.sanitizeAnswers(assessmentData.answers || {})
    })
    return {
      success: true,
      assessment: response.assessment,
      isNew: response.isNew === true,
      allAssessments: response.assessments || []
    }
  }

  static async deleteAssessment(assessmentId) {
    this.requireContext({ engagement: true })
    const response = await this.transport.remove({
      organisation_id: this.organisationId,
      engagement_id: this.engagementId,
      assessment_id: assessmentId
    })
    return { success: true, assessments: response.assessments || [] }
  }

  static sanitizeAnswers(answers) {
    const sanitized = {}
    Object.keys(answers).forEach(questionId => {
      if (answers[questionId]) {
        sanitized[questionId] = {
          value: String(answers[questionId].value || ''),
          findings: String(answers[questionId].findings || ''),
          justification: String(answers[questionId].justification || ''),
          recommendations: String(answers[questionId].recommendations || ''),
          aiAnalysis: String(answers[questionId].aiAnalysis || '')
        }
      }
    })
    return sanitized
  }

  static generateId() {
    return globalThis.crypto?.randomUUID?.() || `00000000-0000-4000-8000-${Date.now().toString().padStart(12, '0').slice(-12)}`
  }
}
